import * as ReselectModule from "reselect";
import { IWorkflowTemplateListState } from ".";
import { IApplicationState } from "..";

export const selectWorkflowTemplateList: ReselectModule.Selector<
  IApplicationState,
  IWorkflowTemplateListState
> = (state) => state.workflowTemplateList;
